import { DOMAIN_DETAIL } from "../Types/types";

const intialState = {
  menuList: [
    {
      name: "Jobs",
      path: "/jobs",
      icon: "bag-icon.svg",
      activeIcon: "bag-icon-pink.svg",
      showInDesktop: true,
      showInMobile: true,
    },
    {
      name: "Candidates",
      path: "/candidates-management",
      icon: "personality-wight.svg",
      activeIcon: "personality-pink.svg",
      showInDesktop: true,
      showInMobile: true,
    },
    {
      name: "Assessments",
      icon: "shield-trust.svg",
      activeIcon: "shield-trust-pink.svg",
      showInDesktop: true,
      showInMobile: true,
      subMenu: [
        { name: "My Assessments", path: "/assessments" },
        { name: "Test Library", path: "/gappeo-tests" },
        { name: "My Tests", path: "/my-tests" },
        { name: "My Questions", path: "/my-questions" },

      ]
    },
    {
      name: "Insights ",
      icon: "analytics.svg",
      showInDesktop: true,
      showInMobile: false,
      subMenu: [
        { name: "Dashboard", path: "/dashboard" },
        { name: "Assessments", path: "/reports" },
        { name: "Voice interview", path: "/voice-interviews-report" },
        { name: "Video interview", path: "/video-interviews-report" },
      ]
    },
    {
      name: "Settings",
      icon: "settings-icon-white.svg",
      showInDesktop: true,
      showInMobile: false,
      subMenu: [
        { name: "API Keys", path: "/keys" },
        { name: "Companies", path: "/companies" },
        { name: "Users", path: "/company-members" },
        { name: "Company Profile", path: "/profile" },
        { name: "Usage and Plan", path: "/plan" },
      ]
    },
  ],
  adminMenuList: [
    {
      name: "Assessments",
      icon: "shield-trust.svg",
      subMenu: [
        { name: "My Questions", path: "/my-questions" }
      ]
    },
    {
      name: "Users",
      path: "/users",
      icon: "users.svg",
    }
  ],
};

export default function layoutReducer(state = intialState, action) {
  let stateCopy = JSON.parse(JSON.stringify(state));
  switch (action.type) {
    case DOMAIN_DETAIL:
      stateCopy.domainDetails = action.payload;
      localStorage.setItem("domainDetails", JSON.stringify(action.payload));
      return stateCopy;
    default:
      return stateCopy;
  }
}
